import { MDXProvider } from '@mdx-js/react';
import { generateBreadcrumbStructuredData } from 'src/lib/utils';
import { DocsProvider } from '../../../contexts/docs';
import { OpenAPIProvider } from '../../../contexts/docs/openapi';
import { LinkOpenAPIProvider } from '../../../contexts/docs/openapi/link';
import DeferredRedirectTracker from '../DeferredRedirectTracker';
import KeypressWrapper from '../KeypressWrapper';
import { filterTableOfContents } from '../utilities';
import ErrorBoundary from './ErrorBoundary';
import LegacyDocsRedirects from './LegacyDocsRedirects';
import MDXComponents from './MDXComponents';
import MetaTags from './MetaTags';
import RouterHooks from './RouterHooks';
import { GetPageComponent } from './util';

import { FlagWrapper } from '../Layout/FlagWrapper';
import './index.module.scss';

const DocsBeta = ({ Component, pageProps, pathname }) => {
  const Page = GetPageComponent(pathname);
  const tableOfContents = Component.layoutProps.tableOfContents;
  const metadata = Component.layoutProps.metadata;

  return (
    <>
      <LegacyDocsRedirects />
      <MetaTags metadata={metadata} />
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            generateBreadcrumbStructuredData({ pathname }),
          ),
        }}
      />
      <DocsProvider
        // instead of using a dispatch to set TOC, set value
        // because the TOC was being set to null momentarily upon route change
        value={{
          tableOfContents: filterTableOfContents(tableOfContents, metadata),
          metadata,
        }}
      >
        <DeferredRedirectTracker />
        <OpenAPIProvider>
          <LinkOpenAPIProvider>
            <RouterHooks />
            <KeypressWrapper>
              <MDXProvider components={MDXComponents}>
                <ErrorBoundary>
                  <Page>
                    <FlagWrapper metadata={metadata}>
                      <Component {...pageProps} />
                    </FlagWrapper>
                  </Page>
                </ErrorBoundary>
              </MDXProvider>
            </KeypressWrapper>
          </LinkOpenAPIProvider>
        </OpenAPIProvider>
      </DocsProvider>
    </>
  );
};

DocsBeta.displayName = 'DocsBeta';

export default DocsBeta;
